import Logo from "./components/Logo";
import { CloudDownload } from "@mui/icons-material";
import notEmptyPassword from "../../utility/validations/notEmptyPassword";
import { Fragment, useEffect } from "react";
import {
  getSharedData,
  getSharedDataId,
  sharedFileData,
} from "../SharedFiles/Actions/getSharedData";
import { downloadSharedData } from "../../store/actions/shared/downloadSharedData";
import { Grid2, Typography } from "@mui/material";
import useUIBp from "../../Hooks/useUIBoilerplate";
import useURLQuery from "../../Hooks/useURLQuery";
import { useWorker } from "../../Hooks/useWorker";
import { UIactions } from "../../store/slices/UI";
import { workerActions } from "../../store/slices/workers";
import SlimAlert from "../UI/GeneralPurpose/SlimAlert";
import TextField from "../UI/GeneralPurpose/SimpleTextField";
import Button from "../UI/GeneralPurpose/Button";
import Locale from "../Dashboard/Components/TopBar/Buttons/Locale";

const UIText = {
  "es-CL": { placeholder: "Contraseña de descarga" },
  "en-US": { placeholder: "Download password" },
};
const UITextBtn = {
  "es-CL": { label: "Descargar" },
  "en-US": { label: "Download" },
};

const UIText1 = {
  "es-CL": {
    text1: "Archivo/Directorio: ",
    info: "Este archivo/directorio fue compartido por nuestra plataforma de respaldo CLONER, si deseas conocer más sobre nuestro servicio por favor completa el formulario de contacto. www.cloner.cl",
    linkError:'Lo sentimos! Hubo un error al intentar obtener la información del enlace de descarga. Confirmar que el enlace haya sido copiado correctamente o que no haya sido eliminado',
  },
  "en-US": {
    text1: "File/Directory: ",
    info: "This file/folder was shared through our backup platform CLONER, if you wish to know more about our service please fill the contact form. www.cloner.cl",
    linkError:'Sorry! There was an error trying to fetch the download link data. Verify that the link was copied correctly or that the link has not been deleted',
  },
};

const passwordFieldUI = "password";

const SharedDownload = () => {
  const { dispatch, UI, warehouse, settings } = useUIBp();
  const { user, id } = useURLQuery();
  const locale = settings.locale ?? "es-CL";
  const { done, error } = useWorker(getSharedDataId);
  const { text1, info, linkError } = UIText1[locale];
  const sharedLink = warehouse[sharedFileData] ?? {};
  const passwordField = UI[passwordFieldUI] ?? {};
  const { value: password, error: passError } = passwordField;

  useEffect(() => {
    if (!done) {
      dispatch(getSharedData({ user, id }));
    }
  }, [dispatch, done, id, user]);

  useEffect(() => {
    dispatch(UIactions.clear(passwordFieldUI));
    return () => {
      dispatch(UIactions.clear(passwordFieldUI));
      dispatch(workerActions.clear(getSharedDataId));
    };
  }, [dispatch]);

  const validate = () => {
    if (sharedLink.has_password) {
      dispatch(
        UIactions.validateField({
          id: passwordFieldUI,
          force: true,
          fn: notEmptyPassword,
          locale,
        })
      );
    }
  };

  const submit = () => {
    if (!passError) {
      dispatch(
        downloadSharedData({
          ...sharedLink,
          password,
          locale,
        })
      );
    }
  };

  return (
    <Grid2
      container
      sx={{ width: "100vw", height: "100vh" }}
      alignContent="space-between"
    >
      <Grid2
        container
        item
        size={12}
        padding={2}
        justifyContent="end"
      >
        <Locale />
      </Grid2>
      <Grid2 container size={12} rowGap={3}>
        <Logo />
        {done && error ? (
          <Grid2 container size={12} justifyContent="center">
            <SlimAlert
              notCollapse
              {...{ errors: [linkError], severity: "error", size: 4 }}
            />
          </Grid2>
        ) : null}
        {done && !error ? (
          <Fragment>
            <Grid2 container size={12} justifyContent="center">
              <Grid2 item size="auto">
                <Typography fontSize={20}>
                  {text1}
                  {sharedLink.name}
                </Typography>
              </Grid2>
            </Grid2>
            {sharedLink.has_password ? (
              <Grid2 container size={12} justifyContent="center">
                <TextField
                  tagError
                  {...{
                    id: passwordFieldUI,
                    UIText,
                    onKeyDown: validate,
                    submit,
                    type: "password",
                    validation: notEmptyPassword,
                    xs: 4,
                  }}
                />
              </Grid2>
            ) : null}
            <Grid2 container size={12} justifyContent="center">
              <Button
                {...{
                  disabled: !!passError,
                  UIText: UITextBtn,
                  startIcon: <CloudDownload />,
                  onMouseDown: validate,
                  onClick: submit,
                }}
              />
            </Grid2>
            <Grid2 container size={12} justifyContent="center">
              <SlimAlert
                notCollapse
                {...{ errors: [info], severity: "info", size: 4 }}
              />
            </Grid2>
          </Fragment>
        ) : null}
      </Grid2>
      <Grid2 size={12}></Grid2>
    </Grid2>
  );
};

export default SharedDownload;
